export default "__VITE_ASSET__DAaOCxLk__"